import { FilterParam, serializeFilters } from "./FilterParam";
import { Sort, serializeSortParam } from "./SortParam";
import { IColumnSetting, ColumnSettingsParam, serializeColumnSettingsParam } from "./ColumnSettingsParam";


export interface GridMetaData {
    page: number;
    pageSize: number;
    sort?: Sort[] | null;
    filterParam?: FilterParam | null;
    gridPreferences?: IColumnSetting[];
}

const createUrlSearchParams = (metadata: GridMetaData) => {
    let paramInit: any = {
        pg: metadata.page,
        sz: metadata.pageSize
    };
    
    const filterParam = serializeFilters(metadata.filterParam);
    if (filterParam) {
        paramInit.filter = filterParam;
    }

    if (metadata.sort !== undefined || metadata.sort !== null) {
        const sortParam = serializeSortParam({
            values: metadata.sort ?? []
        });
        paramInit.sort = sortParam;
    }

    if (metadata.gridPreferences !== undefined || metadata.gridPreferences !== null) {
        console.log(metadata.gridPreferences);
        const gridPreferencesParam = serializeColumnSettingsParam({
            values: metadata.gridPreferences ?? []
        });
        paramInit.gridPreferences = gridPreferencesParam;
    }

    return new URLSearchParams(paramInit);    
};

export { createUrlSearchParams };